import { CartTheme } from '../../base/tokens'

export const cart: CartTheme = {
  button: {
    container: "fixed right-20 top-16 z-20",
    wrapper: "relative flex h-14 w-14 items-center justify-center",
    hexagon: {
      outer: "absolute inset-0 bg-cyan-400/5 scale-[1.35] clip-path-hexagon",
      middle: "absolute inset-0 border border-cyan-400/20 scale-[1.2] clip-path-hexagon animate-pulse-slow",
      inner: "relative flex h-14 w-14 items-center justify-center clip-path-hexagon border border-cyan-500/20 bg-gray-900/80 before:absolute before:inset-0 before:bg-gradient-to-br before:from-cyan-400/5 before:to-transparent"
    },
    icon: {
      className: "w-7 h-7 relative z-10 text-cyan-400 hover:text-cyan-300 transition-colors duration-300",
      svg: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" 
          d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
      </svg>`
    },
    counter: {
      wrapper: "absolute -top-2 -right-2 z-[60]",
      container: "relative flex h-6 w-6 items-center justify-center",
      background: "absolute inset-0 bg-orange-400 rounded-full animate-pulse-slow",
      text: "relative text-xs font-medium text-gray-900"
    }
  },
  panel: {
    overlay: "fixed inset-0 bg-gray-900/70 backdrop-blur-sm transition-opacity duration-300 z-40",
    container: "fixed inset-y-0 right-0 w-full md:w-96 border-l border-cyan-500/20 bg-gray-900/95 backdrop-blur-sm",
    header: {
      wrapper: "p-6 border-b border-cyan-500/20",
      row: "flex items-center justify-between",
      title: "text-xl font-medium text-cyan-400",
      closeButton: {
        container: "relative group/btn",
        wrapper: "relative h-9 w-9 flex items-center justify-center rounded-xl border border-cyan-500/20 bg-gray-900/80 overflow-hidden hover:border-red-500/30 transition-all duration-300",
        background: "absolute inset-0 bg-red-500/5 rounded-xl scale-[2] opacity-0 group-hover/btn:opacity-100 transition-opacity duration-300",
        icon: "w-5 h-5 text-cyan-400/70 group-hover/btn:text-red-400 transition-all duration-300 group-hover/btn:rotate-90",
        gradients: {
          before: "before:absolute before:inset-0 before:bg-gradient-to-r before:from-red-500/0 before:to-red-500/0 before:opacity-0 before:transition-opacity before:duration-300 group-hover/btn:before:opacity-100",
          after: "after:absolute after:inset-0 after:bg-gradient-to-r after:from-red-500/0 after:to-red-500/0 after:opacity-0 after:transition-opacity after:duration-300 group-hover/btn:after:opacity-100"
        }
      }
    },
    content: {
      wrapper: "p-6 space-y-0 divide-y divide-cyan-500/20 max-h-[calc(100vh-240px)] overflow-y-auto",
      item: {
        container: "relative group py-3 first:pt-0 last:pb-0",
        title: "text-sm flex-1 truncate font-medium text-cyan-100",
        row: {
          wrapper: "flex items-center justify-between mb-2",
          controls: "flex items-center justify-between"
        },
        removeButton: {
          container: "relative group/btn ml-2 w-6 h-6 flex items-center justify-center",
          background: "absolute inset-0 bg-red-500/5 rounded-full opacity-0 group-hover/btn:opacity-100 transition-opacity duration-300",
          icon: "w-4 h-4 text-cyan-400/70 group-hover/btn:text-red-400 transition-all duration-300 group-hover/btn:rotate-90"
        },
        controls: {
          wrapper: "flex items-center justify-between",
          quantity: {
            wrapper: "flex items-center gap-1 bg-gray-900/50 rounded-md px-1 border border-cyan-500/20",
            button: "w-5 h-5 flex items-center justify-center text-cyan-400/70 hover:text-cyan-400 transition-colors",
            text: "w-5 text-center text-xs text-cyan-100",
            icon: "w-4 h-4"
          }
        }
      }
    },
    footer: {
      container: "absolute bottom-0 left-0 right-0 p-6 border-t border-cyan-500/20 bg-gradient-to-t from-gray-900/95 to-transparent backdrop-blur-sm",
      row: "flex justify-between items-center mb-4",
      total: {
        label: "text-lg font-medium text-cyan-400",
        value: "text-2xl font-semibold text-orange-400"
      },
      button: {
        base: "w-full rounded-xl px-4 py-3 text-sm font-medium transition-all duration-300",
        enabled: "bg-cyan-500 hover:bg-cyan-600 text-white",
        disabled: "bg-gray-500/20 cursor-not-allowed",
        text: {
          enabled: "text-white",
          disabled: "text-gray-400"
        }
      }
    }
  }
}